import React from 'react';
import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';

const Courses = () => {
  const courses = [
    {
      id: 1,
      title: 'Complete Web Development',
      description: 'Learn full-stack web development from scratch',
      duration: '12 weeks',
      price: '$299',
      level: 'Beginner',
      rating: 4.8,
      students: 1250,
    },
    {
      id: 2,
      title: 'Advanced React Patterns',
      description: 'Master advanced React concepts and patterns',
      duration: '8 weeks',
      price: '$199',
      level: 'Advanced',
      rating: 4.9,
      students: 890,
    },
    {
      id: 3,
      title: 'Node.js & Express',
      description: 'Build scalable backend applications',
      duration: '10 weeks',
      price: '$249',
      level: 'Intermediate',
      rating: 4.7,
      students: 1100,
    },
    {
      id: 4,
      title: 'Database Design & SQL',
      description: 'Learn database design and SQL optimization',
      duration: '6 weeks',
      price: '$149',
      level: 'Beginner',
      rating: 4.6,
      students: 750,
    },
  ];

  return (
    <Container fluid>
      <Row className="g-3 mb-3">
        <Col>
          <h2 className="mb-0">Courses</h2>
        </Col>
      </Row>
      <Row className="g-3">
        {courses.map((course) => (
          <Col key={course.id} md={6} lg={4}>
            <Card className="h-100">
              <Card.Header>
                <div className="d-flex justify-content-between align-items-start">
                  <h6 className="mb-0">{course.title}</h6>
                  <Badge bg="primary">{course.level}</Badge>
                </div>
              </Card.Header>
              <Card.Body>
                <p className="text-body-secondary mb-3">{course.description}</p>
                <div className="row g-2 mb-3">
                  <div className="col-6">
                    <small className="text-body-secondary">Duration:</small>
                    <p className="mb-0 small">{course.duration}</p>
                  </div>
                  <div className="col-6">
                    <small className="text-body-secondary">Price:</small>
                    <p className="mb-0 small fw-bold text-primary">
                      {course.price}
                    </p>
                  </div>
                  <div className="col-6">
                    <small className="text-body-secondary">Rating:</small>
                    <p className="mb-0 small">⭐ {course.rating}</p>
                  </div>
                  <div className="col-6">
                    <small className="text-body-secondary">Students:</small>
                    <p className="mb-0 small">{course.students}</p>
                  </div>
                </div>
                <Button variant="primary" size="sm" className="w-100">
                  Enroll Now
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Courses;
